import { billsToPayStatus } from '@constants/Color'
// Mutations
export const SET_SUPPLIERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.suppliers.data = payload
    state.suppliers.lastUpdate = new Date()
  }
}
export const ADD_SUPPLIERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.suppliers.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.suppliers.data.push(data)
      }
    })
  }
}
export const SET_SUPPLIERS_LOADING = (state, payload) => {
  state.suppliers.loading = payload
}

export const SET_BILLS_TO_PAY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.billsToPay.data = payload
    state.billsToPay.lastUpdate = new Date()
  }
}
export const ADD_BILLS_TO_PAY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.billsToPay.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.billsToPay.data.push(data)
      }
    })
  }
}
export const SET_BILLS_TO_PAY_LOADING = (state, payload) => {
  state.billsToPay.loading = payload
}

export const SET_DEPARTMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.departments.data = payload
    state.departments.lastUpdate = new Date()
  }
}
export const ADD_DEPARTMENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.departments.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.departments.data.push(data)
      }
    })
  }
}
export const SET_DEPARTMENTS_LOADING = (state, payload) => {
  state.departments.loading = payload
}

export const SET_CATEGORIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.categories.data = payload
    state.categories.lastUpdate = new Date()
  }
}
export const ADD_CATEGORIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.categories.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.categories.data.push(data)
      }
    })
  }
}
export const SET_CATEGORIES_LOADING = (state, payload) => {
  state.categories.loading = payload
}

export const SET_BILLS_STATUS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.billsStatus.data = payload
      .sort((a, b) => {
        return a.order - b.order
      })
      .map((item) => {
        return {
          ...item,
          color: billsToPayStatus[item.value],
        }
      })

    state.billsStatus.lastUpdate = new Date()
  }
}
export const SET_FORNECEDORES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.fornecedores.data = payload
    state.fornecedores.lastUpdate = new Date()
  }
}
export const ADD_FORNECEDORES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.fornecedores.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.fornecedores.data.push(data)
      }
    })
  }
}
export const SET_FORNECEDORES_LOADING = (state, payload) => {
  state.fornecedores.loading = payload
}

export const SET_BILLS_TO_RECEIVE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.billsToReceive.data = payload
    state.billsToReceive.lastUpdate = new Date()
  }
}
export const ADD_BILLS_TO_RECEIVE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.billsToReceive.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.billsToReceive.data.push(data)
      }
    })
  }
}
export const SET_BILLS_TO_RECEIVE_LOADING = (state, payload) => {
  state.billsToReceive.loading = payload
}

export const SET_SERVICO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.servico.data = payload
    state.servico.lastUpdate = new Date()
  }
}
export const ADD_SERVICO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.servico.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.servico.data.push(data)
      }
    })
  }
}
export const SET_SERVICO_LOADING = (state, payload) => {
  state.servico.loading = payload
}

export const SET_OBSERVATIONS_BILLS_TO_RECEIVE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.observationsBillsToReceive.data = payload
    state.observationsBillsToReceive.lastUpdate = new Date()
  }
}
export const ADD_OBSERVATIONS_BILLS_TO_RECEIVE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.observationsBillsToReceive.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.observationsBillsToReceive.data.push(data)
      }
    })
  }
}
export const SET_OBSERVATIONS_BILLS_TO_RECEIVE_LOADING = (state, payload) => {
  state.observationsBillsToReceive.loading = payload
}

export const SET_PJS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.pjs.data = payload
    state.pjs.lastUpdate = new Date()
  }
}
export const ADD_PJS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.pjs.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.pjs.data.push(data)
      }
    })
  }
}
export const SET_PJS_LOADING = (state, payload) => {
  state.pjs.loading = payload
}
export const SET_FATURAMENTO_ANEXOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.faturamentoAnexos.data = payload
    state.faturamentoAnexos.lastUpdate = new Date()
  }
}
export const ADD_FATURAMENTO_ANEXOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.faturamentoAnexos.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.faturamentoAnexos.data.push(data)
      }
    })
  }
}
export const SET_FATURAMENTO_ANEXOS_LOADING = (state, payload) => {
  state.faturamentoAnexos.loading = payload
}

export const SET_SOLICITATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.solicitations.data = payload
    state.solicitations.lastUpdate = new Date()
  }
}
export const ADD_SOLICITATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.solicitations.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.solicitations.data.push(data)
      }
    })
  }
}
export const SET_SOLICITATIONS_LOADING = (state, payload) => {
  state.solicitations.loading = payload
}
export const SET_SOLICITATIONS_PENDING_COUNT = (state, payload) => {
  state.solicitationsPendingCount.data = Number(payload) || 0
  state.solicitationsPendingCount.lastUpdate = new Date()
}
export const SET_SOLICITATIONS_PENDING_COUNT_LOADING = (state, payload) => {
  state.solicitationsPendingCount.loading = payload
}

export const SET_FILIAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.filiais.data = payload
    state.filiais.lastUpdate = new Date()
  }
}
export const ADD_FILIAIS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.filiais.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.filiais.data.push(data)
      }
    })
  }
}
export const SET_FILIAIS_LOADING = (state, payload) => {
  state.filiais.loading = payload
}

